// @ts-check
export class Login{
/**
 * 
 * @param {any} main 
 * @param {any} state 
 */
constructor(main,state){
this.controller = new AbortController();
this.cleanups = [];
this.evtHandlers = [];
this.main = main;
this.state = state;
this.option = null;
this.getTemplate();
}//

async setDisplay(){
if(!this.state.isInit){
  //login link likely clicked from home menu or session timed out, and you must re-login
  this.option = this.main.getCache('option');
}

if(!this.option){
let r = await this.main.fu.fetch({link:this.main.fu.getApi('app/option'),method:'POST'});
if(r){
  this.option = r;
}
}
//finally
this.main.setTheme(this.option);
}//func

async getTemplate(){
await this.setDisplay();
  //always: the dynamic nature doesnt allow reuse
let $this = this;//cu
this.loginComponent = this.main.pbu.createElement('main',['form-signin','w-100','m-auto']);
this.main.pbu.appendChild(this.loginComponent,
`

  <div>
   <p class="text-center"><img width="72" height="57" src="${this.option.logoUrl}" /></p>
   <h3 class="h3 mb-3 fw-normal sp-title text-center">Please sign in</h3>
  <form class="auth">
    <section>
    ${this.main.pbu.createFormControl({serialize:true,title:"Email",type:'email',clasz:['email','sp-validation-required']})}
    ${this.main.pbu.createFormControl({serialize:true,title:"Password",type:'password',clasz:['password','sp-validation-required']})}
    <div>
    <p class=""><a class="sp-forgot-password" type="button">Forgot password?</a></p>
    <p class="text-center small ${this.main.pbu.showIf(this.main.isSite)}"><a href="/app/register">Don't have an account? Sign up</a></p>
    </div>
   </section>
  </form>
  <p> Go to <a class="sp-route-link sp-detail sp-slug-link me-2" href="/">Home page</a></p>
 <div>`
);
  

this.main.pbu.mount(this.loginComponent);
//
this.authForm = this.loginComponent.querySelector('form.auth');
this.formTitle = this.loginComponent.querySelector('h3.sp-title');
this.emailControl = this.loginComponent.querySelector('input.email');
this.passwordControl = this.loginComponent.querySelector('input.password');
this.forgotPasswordButton = this.loginComponent.querySelector('a.sp-forgot-password');
this.authForm.appendChild(this.main.tu.getSaveButton({component:this,cb:this.getToken,cbIsMain:true,textContent:"Login",clasz:['w-100']}));

addEvents();
//finally
function addEvents(){
$this.main.pbu.listen($this.forgotPasswordButton,'click',async(e)=>{
e.preventDefault();
await $this.resetPassword();
},$this);
}//inner
}//func

async getToken(){
if(! this.main.vu.validate(this.authForm.querySelectorAll('input.sp-validation'))){
    return;
}
this.user = {
email:this.emailControl.value,
password:this.passwordControl.value,
clientUUID:this.main.utils.getUUID()
};
let r = await this.main.fu.fetch({
  link:this.main.fu.getApi('app/login',[{n:'stage',v:'getToken'}]),
  body:JSON.stringify(this.user),
  component:'login'
});
if(r){
this.authTokenTemplate = this.main.tu.authToken({component:this,cb:this.login,tokenUuid:r,cbIsMain:true,withTimer:true,email:this.user.email});
this.main.pbu.replace(this.authForm,this.authTokenTemplate);
}
}//func
async login(){
//NOTE: nextState link had been built
//onlt get request is considered for next state
let isGet;
let nextStateUrl = "";
if(this.state.nextState){
  if(this.state.nextState.body){
    isGet = false;
    nextStateUrl = ""
  }else{
    isGet = true;
    nextStateUrl = this.state.nextState.link;
  }
}

let r = await this.main.fu.fetch({
  link:this.main.fu.getApi('app/login',[{n:'stage',v:'login'},{n:'nextStateUrl',v:nextStateUrl}]),
  body:JSON.stringify(this.user),
  component:'login'
});
let tempData,dashboardState;
if(r){
tempData = r;
if(this.state.nextState){
  //usually when session has expired
    if(isGet){
      this.state.nextState.stateObject= tempData.stateObject;
      //this.state.nextState.prevComponentClasz = this;
     this.main.navigate(this.state.nextState);
    }else{
      //allow client review and re-submit their post after re-authentication
      this.main.dashboard.mount(null);
    }
      
    }else{
    this.main.setTheme(tempData.option);
    this.main.setCache('user',tempData.user);
    this.main.setCache('option',tempData.option);
    dashboardState = this.main.getState(this.main.getLink('dashboard'),false);
    //dashboardState.prevComponentClasz = this;
    this.main.navigate(dashboardState);
    }
}
}//func

async resetPassword(){
let $this = this;
this.formTitle.textContent="Forgot your password?";
this.authForm.innerHTML = 
`
<section>
<p>You will receive a token to reset your password</p>
    ${this.main.pbu.createFormControl({serialize:true,title:"Email",type:'email',clasz:['email','sp-validation-required']})}
</section>
`;
this.emailControl = this.authForm.querySelector('input.email');
this.authForm.appendChild(this.main.tu.getSaveButton({component:$this,cb:getToken,cbIsMain:false,textContent:"Submit",clasz:['w-100']}));
//event
async function getToken(){
if(! $this.main.vu.validate($this.emailControl)){return;}
let r = await $this.main.fu.fetch({
  link:$this.main.fu.getApi('app/resetpassword',[{n:'stage',v:'getToken'}]),
  body:JSON.stringify({email:$this.emailControl.value}),
});
if(r){
$this.authTokenTemplate = $this.main.tu.authToken({component:$this,cb:reset,cbIsMain:false,tokenUuid:r,withTimer:true,email:$this.emailControl.value});
$this.main.pbu.replace($this.authForm,$this.authTokenTemplate);
}
}//inner

function reset(){
$this.formTitle.textContent="Reset your password";
      $this.authForm.innerHTML = 
      `
      ${$this.main.pbu.createFormControl({serialize:true,title:"Password",type:'password',clasz:['password','sp-validation-required']})}
      ${$this.main.pbu.createFormControl({serialize:true,title:"Confirm Password",type:'password',clasz:['confirm-password','sp-validation-required']})}
      `;
      $this.passwordControl = $this.authForm.querySelector('input.password');
      $this.confirmPasswordControl = $this.authForm.querySelector('input.confirm-password');
      $this.authForm.appendChild($this.main.tu.getSaveButton({component:$this,cb:save,cbIsMain:false,textContent:"Reset",clasz:['w-100']}));
}//inner

async function save(){
if(! $this.main.vu.validate($this.passwordControl,$this.confirmPasswordControl )){return;}
        if($this.passwordControl.value != $this.confirmPasswordControl.value){
          $this.main.utils.notify('Password must be same',{level:2});
          return;
        }
        //now submit password for reset
        let r = await $this.main.fu.fetch({
          link : $this.main.fu.getApi('app/resetpassword',[{n:'stage',v:'update'}]),
          body : JSON.stringify({email:$this.emailControl.value,password:$this.passwordControl.value})
        });
        if(r=='ok'){
          $this.formTitle.textContent="Reset successful, please login to your account";
          $this.authForm.innerHTML = `<a href="/app/login" class="btn btn-primary w-100 py-2" >Submit</button>`;
        }
}//inner
///
}//func

}//#class
